import { render, staticRenderFns } from "./calorie-macro-nutrient-intake.vue?vue&type=template&id=6ad75156&"
import script from "./calorie-macro-nutrient-intake.vue?vue&type=script&lang=js&"
export * from "./calorie-macro-nutrient-intake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CFormControl: require('@chakra-ui/vue').CFormControl, CBox: require('@chakra-ui/vue').CBox})
